// extracted by mini-css-extract-plugin
export var closeButton = "_ii-2";
export var closeButtonIcon = "_ii-3";
export var lightboxContent = "_ii-1";
export var lightboxOverlay = "_ii-0";